<!--
 * @Author: xh
 * @Description: 当前能力模型
 * @Date: 2021-11-06 16:48:13
 * @LastEditTime: 2021-11-09 19:18:45
 * @FilePath: \eec-mobile\src\views\student\index.vue
-->
<template>
  <div class="app">
    <h3>{{ userName }}当前能力模型:</h3>
    <RadarMap :chartsData="chartsData"></RadarMap>
    <div class="content">
      <div class="content-box" v-for="(item, index) in tableData" :key="index">
        <div class="content-title">
          毕业要求{{ item.claimcode }}:{{ item.claimcontent }}
        </div>
        <div class="content-center">支撑目标:{{ item.goals }}</div>
        <div class="content-point">
          <div>直接达成度：{{ item.analysis }}</div>
          <div>间接达成度：{{ item.score }}</div>
          <div>期望达成度：{{ item.target }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadarMap from "@/components/echaars/RadarMap";
export default {
  name: "Studentclaims",
  components: { RadarMap },
  data() {
    return {
      params: [],
      chartsData: {},
      tableData: [],
      userName: ""
    };
  },
  created() {
    const params = window.location.hash.split("?")[1].split("&");
    this.userName = decodeURI(params[6]);
  },
  mounted() {
    this.getChartsData();
  },
  methods: {
    getChartsData() {
      // let data = {
      //   grade: params[0],
      //   classId: params[1].split(","),
      //   id: params[2],
      //   specialtyId: params[3],
      //   userId: params[4],
      //   versionId: params[5]
      // };
      // const res = await this.$post(
      //   "/basic/achieve/analysis/studentClaims",
      //   data
      // );
      const res = {
        status: 1,
        state: "success",
        message: "操作成功 !",
        data: {
          names: [
            "1.工程知识",
            "2.问题分析",
            "3.设计/开发解决方案",
            "4.研究",
            "5.使用现代工具",
            "6.工程与社会",
            "7.环境和可持续发展",
            "8.职业规范",
            "9.个人和团队",
            "10.沟通",
            "11.项目管理",
            "12.终身学习"
          ],
          indevaval: {
            name: "间接达成度",
            value: [
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0",
              "0.0"
            ]
          },
          sign: ["实际达成度", "目标达成度"],
          claims: [
            {
              score: 0.0,
              claimcode: "1",
              claimname: "工程知识",
              claimcontent:
                "具有从事机械工程领域工作所需的数学、自然科学、工程基础和专业知识，并能在分析和解决复杂工程问题中加以利用。",
              claimId: "719662872505876480",
              analysis: "0.64",
              goals: "培养目标 3、培养目标 2、培养目标 4、培养目标 5",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "2",
              claimname: "问题分析",
              claimcontent:
                "能够应用数学、自然科学和工程科学的基本原理，识别、表达并通过文献研究分析机电系统和部件设计、制造工艺、运动控制等复杂工程问题，并获得合理有效结论。",
              claimId: "719663875020029952",
              analysis: "0.69",
              goals: "培养目标 2、培养目标 1",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "3",
              claimname: "设计/开发解决方案",
              claimcontent:
                "具有针对机电工程领域中的复杂系统、部件、控制过程和工艺流程的设计／开发能力，能够在设计环节中体现创新意识并考虑社会、健康、安全、法律、文化及环境等因素。",
              claimId: "719664212443398144",
              analysis: "0.69",
              goals: "培养目标 3、培养目标 2、培养目标 4",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "4",
              claimname: "研究",
              claimcontent:
                "具有运用科学原理和科学方法开展复杂机械工程问题研究及实验的能力，能够对研究及实验结果进行分析并通过信息综合得到合理有效的结论。",
              claimId: "719665007930900480",
              analysis: "0.64",
              goals: "培养目标 5、培养目标 1、培养目标 2",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "5",
              claimname: "使用现代工具",
              claimcontent:
                "在复杂机械工程活动中，具有选择和运用技术、资源和信息工具进行工程实践的能力。",
              claimId: "719665163124342784",
              analysis: "0.69",
              goals: "培养目标 3、培养目标 1",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "6",
              claimname: "工程与社会",
              claimcontent:
                "能够评价机械工程实践和复杂工程问题解决方案对健康、安全、法律和文化问题的影响，并理解应承担的责任。",
              claimId: "719665278845190144",
              analysis: "0.67",
              goals: "培养目标 3、培养目标 6",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "7",
              claimname: "环境和可持续发展",
              claimcontent:
                "能够理解和评价针对复杂工程问题的机械工程实践对环境、社会可持续发展的影响。",
              claimId: "719665390254292992",
              analysis: "0.68",
              goals: "培养目标 3、培养目标 5",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "8",
              claimname: "职业规范",
              claimcontent:
                "具有人文社会科学素养、社会责任感，能够在工程实践中理解并遵守工程职业道德和规范，履行责任。",
              claimId: "719665753594265600",
              analysis: "0.61",
              goals: "培养目标 2",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "9",
              claimname: "个人和团队",
              claimcontent:
                "具有团队合作精神和在多学科交叉环境中发挥个人作用的能力。",
              claimId: "719665885849059328",
              analysis: "0.68",
              goals: "培养目标 4",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "10",
              claimname: "沟通",
              claimcontent:
                "具有在复杂机械工程活动中与业界同行和社会公众进行有效沟通的能力，具备一定的国际视野和跨文化交流的能力。",
              claimId: "719666044054011904",
              analysis: "0.68",
              goals: "培养目标 3、培养目标 4",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "11",
              claimname: "项目管理",
              claimcontent:
                "理解并掌握机械工程管理原理与经济决策方法，并能在多学科环境中应用。",
              claimId: "719666158285881344",
              analysis: "0.67",
              goals: "培养目标 2、培养目标 4",
              target: "0.70"
            },
            {
              score: 0.0,
              claimcode: "12",
              claimname: "终身学习",
              claimcontent:
                "了解本专业前沿发展现状和趋势，具有终生教育的意识和不断学习的能力。",
              claimId: "719666288837787648",
              analysis: "0.67",
              goals: "培养目标 4",
              target: "0.70"
            }
          ],
          analysis: {
            name: "实际达成度",
            value: [
              "0.64",
              "0.69",
              "0.69",
              "0.64",
              "0.69",
              "0.67",
              "0.68",
              "0.61",
              "0.68",
              "0.68",
              "0.67",
              "0.67"
            ]
          },
          title: "机械设计制造及其自动化专业2016机械01毕业要求达成情况分析",
          target: {
            name: "目标达成度",
            value: [
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70",
              "0.70"
            ]
          }
        }
      };
      if (res.status == 1) {
        this.tableData = res.data.claims;
        this.chartsData = res.data;
      } else {
        this.$toast({
          message: res.message,
          position: "bottom"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  height: 100%;
  padding: 20px 5px;
  h3 {
    margin-bottom: 20px;
  }
  .content {
    width: 100%;
    background-color: #eeeeee;
    .content-box {
      margin-bottom: 15px;
      padding: 20px;
      background-color: #fff;
      border: 1px solid #eee;
      .content-title {
        color: #333;
        font-weight: 900;
        margin-bottom: 10px;
        font-size: 14px;
      }
      .content-center {
        margin-bottom: 10px;
        color: #b5b5b5;
        font-size: 12px;
        font-weight: 700;
      }
      .content-point {
        display: flex;
        justify-content: space-around;
        height: 35px;
        font-size: 12px;
        > div {
          width: 33%;
          text-align: center;
          border: 1px solid #eee;
          line-height: 35px;
        }
        > :first-child {
          color: #03b187;
        }
        > :nth-child(2) {
          color: #ffa351;
        }
        > :last-child {
          color: #2098ff;
        }
      }
    }
  }
}
</style>
